const LineSeparator = () => {
  return <hr className="h-px my-8 bg-primary-100 border-0" />;
};

export default LineSeparator;
